import React, {useEffect, useState , useCallback} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {Grid, Paper, Button,} from "@material-ui/core";
import {Formik, Form} from "formik";
import {helpers} from "../../../helper/helper";
import {useSnackbar} from "notistack";
import { useHistory } from "react-router";
import CreateGiftsForm from "./CreateGiftsForm";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        background: 'transparent',
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            padding: theme.spacing(3),
        },
    },
    submit: {
        margin: theme.spacing(4, 0, 1, 0),
    },
    wrapper: {
        position: "relative",
    },
    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "91%",
    },
}));

const CreateGifts = (props) => {
    const Id = props.match.params.id
    const history = useHistory()
    const {enqueueSnackbar} = useSnackbar();
    const classes = useStyles();
    const [img, setImg] = useState(false);
    const [giftsId, setGiftsId] = useState();
    const [editCheck, setEditCheck] = useState(false);
    const [singleGifts, setSingleGifts] = useState();
    
    const [file, setFile] = useState();
    const [image, setImage] = useState([]);
    const initialValues = {
        zole: "",
        popularity: "",
        giftImg: "",
    };
    const editValues = {
        zole: singleGifts && singleGifts.zole ? singleGifts.zole : "",
        popularity:
            singleGifts && singleGifts.popularity ? singleGifts.popularity : "",
        giftImg: singleGifts && singleGifts.giftImg ? singleGifts.giftImg : "",
    };

    const handleSubmit = async (values, action) => {
        let formData = new FormData();
        formData.append("zole", values.zole);
        formData.append("popularity", values.popularity);
        formData.append("giftImg", image ? image[0] : values.giftImg);

        const url = "gifts";
        const result = await helpers.apiCallForm("POST", url, formData);
        if (result.status === 200) {
            
            setImg(true);
            enqueueSnackbar("Gifts Created successfully", {
                variant: 'success',
                autoHideDuration: 3000,
            });

            action.resetForm();
            setImage([])
            history.push("/dashboard/gifts")
        }
        else {
            enqueueSnackbar(result.data ? result.data.message : result.message, {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }
        setImg(false)
    };


    const editGifts = async (values, {resetForm}) => {
        let formData = new FormData();
        formData.append('zole', values.zole);
        formData.append('popularity', values.popularity);
        formData.append('giftImg', image[0] ? image[0] : singleGifts.giftImg);
        const url = `gifts/${Id}`;
        const result = await helpers.apiCallForm("PUT", url, formData);
        if (result.status === 200) {
          
            setEditCheck(false);
            setSingleGifts();
            setImage([]);
            enqueueSnackbar("Gifts Updated successfully", {
                variant: 'success',
                autoHideDuration: 3000,
            });
            history.push("/dashboard/gifts")
        } else {
            enqueueSnackbar(result.data ? result.data.message : result.message, {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }
    };

    const singleGiftsById = useCallback(async (id) => {
        setGiftsId(id);
        const url = `Gifts/${Id}`;
        const result = await helpers.apiCall("get", url);
        if (result.status === 200) {
            setSingleGifts(result.data.result);
            setEditCheck(true);
        } else {
            setEditCheck(false);
        }
    },[Id])

    useEffect(() => {
        if(Id && !editCheck)
        {
            singleGiftsById() 
        }
    }, [singleGiftsById , Id  , editCheck]);

    return (
        <Paper className={classes.paper} square>
            
            <Formik
                enableReinitialize="true"
                initialValues={editCheck ? editValues : initialValues}
                onSubmit={editCheck ? editGifts : handleSubmit}
            >
                {(formik) => {
                    return (
                        <div className="col-md-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">Gift Form</h4>
                <p className="card-description"> Add Gift Form Detail Here </p>
                        <Form autoComplete="off">
                            <CreateGiftsForm formik={formik} setFile={setFile} file={file} singleGifts={singleGifts}
                                             setSingleGifts={setSingleGifts}
                                             image={image}
                                             setImage={setImage} img={img}
                                             giftsId={giftsId}/>
                            <Grid align="right" item style={{marginTop: "10px"}}>
                                <div className={classes.wrapper}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        className={classes.submit}
                                        color="primary"
                                    >
                                        {editCheck ? "UPDATE" : "Create"}
                                    </Button>
                                </div>
                            </Grid>
                        </Form>
                        </div>
                        </div>
                        </div>
                    );
                }}
            </Formik>
        </Paper>
    );
};

export default CreateGifts;
